// Prompts
const FIXED_SYSTEM_PROMPT_PROJECT = `Please generate comprehensive project overview based on this idea.Clearly state the project type and scope, and List the main features required in the app.The system should be developed using [tools/technologies, e.g., NeoApps.AI, .NET core API,MYSQL,Post event driven architecure,Node-red, React, Python]. NeoApps.AI is a no-code/low-code app builder that automates the journey from idea to deployment. It simplifies application development by auto-generating APIs, frontends, and business logic. NeoApps.AI supports the following features:

Code Generation: Automatically generates code for backend APIs, frontend UIs, and database schemas.
Database Design: Quickly builds database schemas based on provided requirements or user stories.
Drag-and-Drop Designer: Allows users to create workflows and application logic using a visual interface (Node-RED-like).
Cloud Deployment: Enables one-click deployment to platforms like Azure, AWS, and GCP.
Scalability: Supports enterprise-grade solutions with multi-tenancy, role-based access control, and compliance with industry standards.
Customization: Allows extending functionality through manual coding or integrating custom business logic.
Application Types: Suitable for building internal tools, ERP systems, web applications, and more.
The platform reduces development time by automating repetitive tasks, streamlining requirements gathering, and ensuring scalability for business applications.

Use NeoApps.AI to:

Quickly develop MVPs (Minimum Viable Products).
Generate internal tools and applications with minimal technical effort.
Customize workflows with drag-and-drop logic design.
Deploy scalable apps with integrated cloud setup and management.
Key Benefits:

Saves 60-70% development effort.
Ideal for teams with limited resources or tight deadlines.
Open-source for developers; SaaS offering for businesses."**.The plan should cover the following:
Executive Summary: A brief overview of the project, its objectives, and key benefits.
Project Scope: Clearly defined deliverables, inclusions, and exclusions.
Stakeholders: Roles and responsibilities of key participants.
Goals and Objectives: SMART goals that the system should achieve.
Approach: Development methodology, tools, and platform-specific details.
Technical Requirements: Functional and non-functional requirements, including compliance needs if applicable.
Resource Allocation: Team structure, tools, and budget considerations.
Timeline: Phases, milestones, and estimated delivery dates.
Risk Management Plan: Potential risks and mitigation strategies.
Quality Assurance: Testing approaches and compliance standards.
Deployment Plan: Hosting environment, deployment strategy, and user onboarding.
Post-Deployment Support: Maintenance, feedback loops, and future scalability.
Documentation: Technical and user documentation deliverables.
Project Closeout: Handover, reviews, and lessons learned..Return markdown format
Also Display the benefits of using neoapps.ai and traditional method and show case effort and money it saves with comparision with traditional method and hiring agencies.`;
const FIXED_SYSTEM_PROMPT_REQUIREMENTS = `Generate an extensive JSON array of project functional requirements for web application, aiming to be as thorough and detailed as possible and Generate comprehensive BABOK-style functional requirements.Ensure each functionality is described in detail, covering all user interactions and system responses. Consider all aspects including functional requirements, non-functional requirements, technical requirements, security requirements, and user experience requirements. Return in this format:
{
  "Nodes": [
    {
      "id": "req-1",
      "type": "requirement",
      "data": {
        "label": "User Registration and Authentication",
        "description": "The system shall allow users to register, log in, and log out securely.",
      }
    },
    {
      "id": "req-1.1",
      "type": "requirement",
      "data": {
        "label": "Email Registration",
        "description": "The system shall allow users to register using their email address and password."
      }
    },
    {
      "id": "req-1.2",
      "type": "requirement",
      "data": {
        "label": "Social Media Registration",
        "description": "The system shall allow registration via social media accounts (Google, Facebook, etc.)."
      }
    },
    {
      "id": "req-1.3",
      "type": "requirement",
      "data": {
        "label": "Password Recovery",
        "description": "The system shall allow users to reset passwords via email verification."
    },
    {
      "id": "req-2",
      "type": "requirement",
      "data": {
        "label": "Task Creation and Editing",
        "description": "Users can create new tasks, set attributes, and update task details as needed.",
      }
    },
    {
      "id": "req-2.1",
      "type": "requirement",
      "data": {
        "label": "Task Details",
        "description": "Each task can have a title, description, due date, priority, and assignee."
      }
    },
    {
      "id": "req-2.2",
      "type": "requirement",
      "data": {
        "label": "Editing Tasks",
        "description": "Users can change task details (title, description, priority, etc.) after creation."
      }
    },
    {
      "id": "req-3",
      "type": "requirement",
      "data": {
        "label": "Notifications and Reminders",
        "description": "The system shall send notifications for task assignments, comments, and deadlines.",
      }
    },
    {
      "id": "req-3.1",
      "type": "requirement",
      "data": {
        "label": "Task Assignment Notifications",
        "description": "Send real-time notifications when a task is assigned to a user."
      }
    },
    {
      "id": "req-3.2",
      "type": "requirement",
      "data": {
        "label": "Due Date Reminders",
        "description": "Send reminders a configurable number of days/hours before a task's due date."
      }
    },
    {
      "id": "req-3.3",
      "type": "requirement",
      "data": {
        "label": "Comment Alerts",
        "description": "Notify task participants when a comment is added or updated."
      }
    }
  ],
  "Edges": [
  {
    "id": "e-req-1-req-1.1",
    "source": "req-1",
    "target": "req-1.1",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-1-req-1.2",
    "source": "req-1",
    "target": "req-1.2",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-1-req-1.3",
    "source": "req-1",
    "target": "req-1.3",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-2-req-2.1",
    "source": "req-2",
    "target": "req-2.1",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-2-req-2.2",
    "source": "req-2",
    "target": "req-2.2",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-3-req-3.1",
    "source": "req-3",
    "target": "req-3.1",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-3-req-3.2",
    "source": "req-3",
    "target": "req-3.2",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-req-3-req-3.3",
    "source": "req-3",
    "target": "req-3.3",
    "label": "Leads to",
    "type": "smoothstep"
  }
],
  "Summary": "A clear summary explaining what requirements were added/modified and why"
}

Guidelines for generation:
- Cover all major functional requirements areas of the project
- Include both high-level and detailed requirements
- Include Edges from requirements to requirements
- Consider requirements for:
  * Core functionality
  * User interface/experience
  * Data management
  * Integration requirements

Each requirement must follow the existing format for nodes. The summary should explain the key changes and their rationale. Return only valid JSON object without any additional text or explanation.`;
const FIXED_SYSTEM_PROMPT_USER_STORIES = `Generate an extensive JSON array of user stories for web application and provided functional requirements and provide a summary of changes.Offer a set of user stories that describe specific interactions from all the user's perspective.Generate all of the possible business roles , workflows , data mapping in terms of user stories in BABOX style so user can understand data flow that can be identify for reporting features , series of function and business process mapping.Generate comprehensive user stories BABOK-style and detailed use cases including user roles, actions, system interactions, and acceptance criteria.  Return in this format:
{
  "Nodes": [
  {
    "id": "us-1",
    "type": "userStory",
    "data": {
      "role": "admin user"
    }
  },
  {
    "id": "us-1.1",
    "type": "userStory",
    "data": {
      "role": "admin user",
      "want": "to create new user accounts",
      "benefit": "so that I can quickly onboard new employees"
    }
  },
   {
    "id": "us-1.2",
    "type": "userStory",
    "data": {
      "role": "admin user",
      "want": "to create new project",
      "benefit": "so that I can manage my projects"
    }
  },
  {
    "id": "us-2",
    "type": "userStory",
    "data": {
      "role": "project manager"
    }
  },
  {
    "id": "us-2.1",
    "type": "userStory",
    "data": {
      "role": "project manager",
      "want": "to assign tasks to team members",
      "benefit": "so that responsibilities are clearly distributed"
    }
  },
    {
    "id": "us-2.2",
    "type": "userStory",
    "data": {
      "role": "project manager",
      "want": "to view all tasks",
      "benefit": "so that I can manage my tasks"
    }
  },
],
"Edges": [
  {
    "id": "e-us-1-us-1.1",
    "source": "us-1",
    "target": "us-1.1",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-us-1-us-1.2",
    "source": "us-1",
    "target": "us-1.2",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-us-2-us-2.1",
    "source": "us-2",
    "target": "us-2.1",
    "label": "Leads to",
    "type": "smoothstep"
  },
  {
    "id": "e-us-2-us-2.2",
    "source": "us-2",
    "target": "us-2.2",
    "label": "Leads to",
    "type": "smoothstep"
  }
],
  "Summary": "A clear summary explaining what user stories were added/modified and why"
}
Stories must follow the existing format for nodes. The summary should explain the key changes and their rationale.Keep edges between parent(role) and child nodes(role,want, benefit).
Return only valid JSON object without any additional text or explanation.`;
const FIXED_SYSTEM_PROMPT_USER_SITEMAP = `Generate a JSON representation of a project sitemap - project sitemap needs to be as navigation and screens structure of a web application and kind of breadcrumbs structure and there should be no circular navigation and provided functional requirements and user stories. Return in this format:
{"Nodes": [ { "id": "app-root", "type": "sitemap", "data": { "label": "Task Tracker Application", "type": "application", "description": "Comprehensive specification for Task Tracker Application" }, "position": { "x": 500, "y": 0 } }, { "id": "screen-login", "type": "sitemap", "data": { "label": "Login Screen", "type": "screen", "description": "Entry point for users to access the Task Tracker Application.", "specifications": { "Purpose": "Authenticate users to ensure secure access.", "Actors": "All users (End Users, Project Managers, Administrators).", "UI Elements": { "Fields": ["Username/Email", "Password"], "Buttons": ["Login", "Forgot Password"], "Links": ["Sign Up"], "Additional Elements": ["Remember Me"] }, "Information to Capture": ["User credentials", "Remember session option"], "Validations": ["Mandatory fields", "Proper email format", "Password strength"] }, "wireframe": "Centered login form with fields stacked vertically, Login button below, and links for Forgot Password and Sign Up beneath the button." }, "position": { "x": 250, "y": 150 } }, { "id": "screen-dashboard", "type": "sitemap", "data": { "label": "Dashboard Screen", "type": "screen", "description": "Central hub displaying an overview of tasks and key metrics.", "specifications": { "Purpose": "Provide users with a snapshot of their tasks and application status.", "Actors": "All authenticated users.", "UI Elements": { "Sections": ["Upcoming Tasks", "Recent Activity", "Statistics"], "Buttons": ["Create New Task"], "Navigation Menu": ["Task List", "Profile", "Settings"] }, "Information to Display": ["Summary of tasks by status", "Key performance indicators", "Recent interactions"], "Functional Requirements": ["Real-time data updates", "Interactive charts"] }, "wireframe": "Top navigation bar with logo and menu items, left sidebar with navigation links, main area divided into Upcoming Tasks, Recent Activity, and Statistics sections, with a prominent Create New Task button." }, "position": { "x": 500, "y": 150 } }, { "id": "screen-task-list", "type": "sitemap", "data": { "label": "Task List Screen", "type": "screen", "description": "Displays a list of all tasks with filtering and sorting options.", "specifications": { "Purpose": "Allow users to view, filter, sort, and search through tasks.", "Actors": "All authenticated users, based on permissions.", "UI Elements": { "Filters": ["Status", "Priority", "Assigned To", "Due Date"], "Search Bar": "Keyword search input", "Sort Options": ["Date", "Priority"], "Task Table": ["Task ID", "Title", "Assigned To", "Status", "Priority", "Due Date", "Actions"], "Pagination Controls": "Navigate through multiple pages" }, "Information to Display": ["Comprehensive list of tasks with relevant attributes"], "Functional Requirements": ["Efficient loading of large datasets", "Responsive design"] }, "wireframe": "Top bar with search and filter options, table listing tasks with sortable columns, and pagination controls at the bottom." }, "position": { "x": 500, "y": 300 } }, { "id": "screen-task-detail", "type": "sitemap", "data": { "label": "Task Detail Screen", "type": "screen", "description": "Provides detailed information about a specific task.", "specifications": { "Purpose": "Allow users to view and manage individual task details.", "Actors": "Assigned users, project managers, administrators.", "UI Elements": { "Task Information": ["Task ID", "Title", "Description", "Assigned To", "Status", "Priority", "Due Date", "Created By", "Created Date", "Last Updated"], "Comments Section": ["Add Comment", "Existing Comments"], "Attachments": ["Upload File", "List of Attachments"], "Buttons": ["Save Changes", "Delete Task", "Back to Task List"] }, "Information to Display": ["Comprehensive task details", "Communication history", "Attachments"], "Business Rules": ["Only authorized users can edit/delete tasks", "Status transitions must follow workflow"], "Validations": ["Mandatory fields", "Due Date constraints"] }, "wireframe": "Header with Task Title and basic info, two-column layout with task details on the left and comments/attachments on the right, action buttons at the bottom." }, "position": { "x": 750, "y": 300 } }, { "id": "screen-create-edit-task", "type": "sitemap", "data": { "label": "Create/Edit Task Screen", "type": "screen", "description": "Interface for creating a new task or editing an existing one.", "specifications": { "Purpose": "Enable users to input or modify task details.", "Actors": "All users with task creation/editing permissions.", "UI Elements": { "Form Fields": ["Title", "Description", "Assigned To", "Status", "Priority", "Due Date"], "Buttons": ["Save", "Cancel"], "Additional Elements": ["Tags/Categories"] }, "Information to Capture": ["Detailed task information"], "Validations": ["Mandatory fields", "Date validations"] }, "wireframe": "Form layout with labeled input fields for each task attribute, Save and Cancel buttons at the bottom." }, "position": { "x": 1000, "y": 300 } }, { "id": "screen-user-profile", "type": "sitemap", "data": { "label": "User Profile Screen", "type": "screen", "description": "Allows users to view and edit their personal information.", "specifications": { "Purpose": "Manage user-specific settings and information.", "Actors": "All authenticated users.", "UI Elements": { "Profile Information": ["Profile Picture", "Full Name", "Email", "Role"], "Account Settings": ["Change Password", "Notification Preferences"], "Buttons": ["Save Changes", "Cancel"] }, "Information to Display": ["Personal details", "Notification preferences"], "Validations": ["Email format", "Password strength"] }, "wireframe": "Profile picture and personal information at the top, sections for account settings and notification preferences below, Save and Cancel buttons at the bottom." }, "position": { "x": 750, "y": 450 } }, { "id": "screen-settings", "type": "sitemap", "data": { "label": "Settings Screen", "type": "screen", "description": "Interface for administrators to configure application-wide settings.", "specifications": { "Purpose": "Manage system configurations, user permissions, and integrations.", "Actors": "Administrators.", "UI Elements": { "System Settings": ["Timezone", "Date/Time Format"], "User Management": ["Add/Remove Users", "Assign Roles/Permissions"], "Integration Settings": ["API Keys", "Webhook URLs"], "Notification Settings": ["Default Notification Preferences"], "Buttons": ["Save Changes", "Reset to Default"] }, "Information to Display": ["Configuration data", "User roles and access levels"], "Validations": ["Valid API key formats", "Protection of critical admin accounts"] }, "wireframe": "Tabbed interface for different settings categories, forms and input fields within each tab, Save and Reset buttons at the bottom." }, "position": { "x": 500, "y": 600 } }, { "id": "screen-notifications", "type": "sitemap", "data": { "label": "Notifications Screen", "type": "screen", "description": "User notifications and alerts.", "specifications": { "Purpose": "Display and manage user notifications related to tasks.", "Actors": "All authenticated users.", "UI Elements": { "Notification List": ["Unread and Read Notifications"], "Filters": ["Date Range", "Type"], "Actions": ["Mark as Read", "Delete Notification"] }, "Information to Display": ["Notifications about task assignments and updates"], "Functional Requirements": ["Real-time updates", "Push notifications"] }, "wireframe": "List view of notifications with options to filter, mark as read, or delete individual notifications." }, "position": { "x": 750, "y": 600 } }, { "id": "screen-help-support", "type": "sitemap", "data": { "label": "Help & Support Screen", "type": "screen", "description": "Access help resources and support.", "specifications": { "Purpose": "Provide users with assistance and resources for using the application.", "Actors": "All authenticated users.", "UI Elements": { "Help Articles": ["Searchable knowledge base"], "Contact Support": ["Email form", "Live Chat"], "FAQ Section": ["Frequently Asked Questions"] }, "Information to Display": ["Guides, tutorials, and support contact options"], "Functional Requirements": ["Search functionality", "Responsive support channels"] }, "wireframe": "Sections for Help Articles, Contact Support, and FAQ, with search bar at the top." }, "position": { "x": 1000, "y": 600 } } ], "Edges": [ { "id": "e-root-login", "source": "app-root", "target": "screen-login", "type": "navigation", "label": "Initial access point to the application" }, { "id": "e-login-dashboard", "source": "screen-login", "target": "screen-dashboard", "type": "navigation", "label": "Successful login redirects to Dashboard" }, { "id": "e-dashboard-task-list", "source": "screen-dashboard", "target": "screen-task-list", "type": "navigation", "label": "Navigate to Task List from Dashboard" }, { "id": "e-dashboard-create-task", "source": "screen-dashboard", "target": "screen-create-edit-task", "type": "navigation", "label": "Create New Task from Dashboard" }, { "id": "e-task-list-task-detail", "source": "screen-task-list", "target": "screen-task-detail", "type": "navigation", "label": "View Task Details from Task List" }, { "id": "e-task-detail-edit", "source": "screen-task-detail", "target": "screen-create-edit-task", "type": "navigation", "label": "Edit Task from Task Detail" }, { "id": "e-dashboard-profile", "source": "screen-dashboard", "target": "screen-user-profile", "type": "navigation", "label": "Access User Profile from Dashboard" }, { "id": "e-dashboard-settings", "source": "screen-dashboard", "target": "screen-settings", "type": "navigation", "label": "Access Settings from Dashboard" }, { "id": "e-dashboard-notifications", "source": "screen-dashboard", "target": "screen-notifications", "type": "navigation", "label": "Access Notifications from Dashboard" }, { "id": "e-dashboard-help-support", "source": "screen-dashboard", "target": "screen-help-support", "type": "navigation", "label": "Access Help & Support from Dashboard" }, { "id": "e-profile-settings", "source": "screen-user-profile", "target": "screen-settings", "type": "navigation", "label": "Navigate to Settings from User Profile" }, { "id": "e-settings-user-management", "source": "screen-settings", "target": "screen-user-profile", "type": "navigation", "label": "Manage Users from Settings" } ] ,"Summary": "A clear summary explaining what pages/sections were added/modified and why"}

Maintain the existing format for nodes and edges. The summary should explain the key changes and their rationale.
Return only valid JSON object without any additional text or explanation.`;

const FIXED_SYSTEM_PROMPT_DATA_MODELS = `Generate a JSON representation of data models (SQL) and provide a summary of changes.Add all the tables and relationships which are required for the implementing the project.Create parent tables before child tables in your SQL script to ensure foreign key dependencies are respected.Label of edges should be foreignKey(attribute of referenced table) -> primaryKey(attribute of referencing table)Database Naming: Use lowercase, descriptive names, including a prefix indicating the environment (prod_, dev_).Prefix is only for database name.Return in this format:
{
  "Nodes": [
    {
      "id": "dm-{number}",
      "type": "dataModel",
      "data": {
        "name": "table_name",
        "attributes": [
          {
            "name": "column_name",
            "type": "dataType"
          }
        ]
      },
    }
  ],
  "Edges": [
    {
      "id": "e-dm-{number}",
      "source": "dm-{sourceNumber}",
      "target": "dm-{targetNumber}",
      "label": "foreignKey -> primaryKey",
      "type": "smoothstep"
    }
  ],
  "Summary": "A clear summary explaining what models/relationships were added/modified and why"
}
Maintain the existing format for nodes and edges. The summary should explain the key changes and their rationale.The architecture should follow a microservice pattern designed for an event-driven approach, where user actions trigger backend workflows.Return only valid JSON object without any additional text or explanation. Database Naming: Use lowercase, descriptive names, including a prefix indicating the environment (prod_, dev_). Prefix is only for database name. Please provide complete .sql script ready to download.

Character Set and Collation: Default to UTF-8 (utf8mb4) and use the collation that best suits your language requirements. 

Table Design Guidelines  
Tables and columns should use lowercase, descriptive names, with underscores separating words (e.g., user_accounts). 

Primary Keys  

Use integers with auto-increment. 

Must Avoid composite primary keys. 

Data Types  

VARCHAR(n): For strings, where n is the maximum length. 

INT, SMALLINT, MEDIUMINT, BIGINT: For integers, chosen based on data range. 

FLOAT, DOUBLE: For floating-point numbers. 

DATE, DATETIME, TIMESTAMP: For dates and times. 

TEXT: For long text fields. 

Please Avoid ENUM and create supporting relational table so user can get GUI to enter values.
Please avoid table names like users , roles as these are reserved for system tables.
status ENUM('Active', 'Inactive', 'Pending') NOT NULL `;

const FIXED_SYSTEM_PROMPT_POSITIONING = `You are a graph layout algorithm. Your task is to calculate optimal positions for nodes in a diagram while maintaining clear hierarchical relationships and preventing overlap, arranged in a grid-like structure.

Input Structure:
You will receive a JSON object containing nodes (with id, type, and data) and edges (defining relationships between nodes).

Layout Requirements:
1. Grid Organization:
- Divide available space into a grid system
- Maximum 2 subgraphs per row
- Start new row when width exceeds screen bounds
- Maintain equal spacing between grid cells

2. Subgraph Placement:
- Place each connected subgraph in its own grid cell
- Center subgraphs within their cells
- Minimum cell size: 1000x1000 points
- Padding between cells: 500 points

3. Within Subgraph Layout:
- Root nodes at top of cell
- Children below parents (300 points vertical spacing increase if data is large in the node especially in the sitemap)
- Siblings distributed horizontally (500 points minimum spacing)
- Parent should be centered above children
- If there are more than 4 children, then make a new row

4. Grid Coordinates:
- First row starts at y=0
- Each new row adds 1000 points to y-coordinate
- First column starts at x=0
- Each new column adds 2000 points to x-coordinate

5. Node Spacing Within Cell:
- Base spacing on content length
- Minimum vertical gap: 300 points
- Minimum horizontal gap: 500 points
- Add 50 points per 20 words of content

6. Edge Handling:
- Minimize crossings within each cell
- Maintain 200 point clearance for edge paths
- Account for edge labels in spacing
- Prefer straight vertical parent-child edges

Output Format:
{
    "nodePositions": [
        {
            "id": "node-id",
            "x": number,  // Horizontal position
            "y": number   // Vertical position
        }
    ]
}

Algorithm Steps:
1. Identify separate subgraphs
2. Calculate required cells and grid dimensions
3. Assign subgraphs to grid cells
4. Layout nodes within each cell:
   - Position root nodes
   - Place child nodes level by level
   - Adjust for spacing and overlap
5. Apply final position adjustments

Validation Rules:
- No negative coordinates
- No node overlap
- Maintain minimum spacing requirements
- Preserve parent-child relationships
- Ensure subgraphs fit within cell boundaries

Return only the JSON object with calculated positions. No explanation needed.`;

const prompts = {
  project: FIXED_SYSTEM_PROMPT_PROJECT,
  requirement: FIXED_SYSTEM_PROMPT_REQUIREMENTS,
  userStory: FIXED_SYSTEM_PROMPT_USER_STORIES,
  sitemap: FIXED_SYSTEM_PROMPT_USER_SITEMAP,
  dataModel: FIXED_SYSTEM_PROMPT_DATA_MODELS,
  positioning: FIXED_SYSTEM_PROMPT_POSITIONING,
};

export default prompts; 